export default "__VITE_ASSET__Dbit5uN7__"